module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n       <label class=\"prop-sublabel label-80\">Vertical Axis</label> \r\n        <div>\r\n            <select name=\"verticalAxis\" id=\"verticalAxis\" >\r\n                <option value=\"linearAxis\">Linear</option>\r\n                <option value=\"logAxis\">Logarithmical</option>\r\n                <option value=\"dateTimeAxis\">Date/Time</option>\r\n                <option value=\"categoryAxis\">Category</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n       <label class=\"prop-sublabel label-80\">Horizontal Axis</label> \r\n        <div>\r\n            <select name=\"horizontalAxis\" id=\"horizontalAxis\" >\r\n                <option value=\"linearAxis\">Linear</option>\r\n                <option value=\"dateTimeAxis\">Date/Time</option>\r\n                <option value=\"categoryAxis\">Category</option>\r\n            </select>\r\n        </div>\r\n   </div>\r\n</div>")
  }
  return __output;

}